import { ILocalizedString } from '../../../../core/interfaces/localized-string';
import { externalLinks } from '../../../../constants/external-links.constants';

export interface INavMenuItem {
  titleDesktop: string;
  titleMobile?: string;
  icon?: string;
  href?: ILocalizedString | null;
  id?: string;
}

type navMenus = 'membership' | 'groupBooking' | 'realEstate';

export type NavMenuItems = {
  [key in navMenus]: INavMenuItem & {
    menuItems?: INavMenuItem[];
  };
};

export const navMenuItems: NavMenuItems = {
  membership: {
    titleDesktop: 'header-menu-membership',
    titleMobile: 'header-menu-membership',
    icon: 'fa-house-heart',
    href: externalLinks.membership,
    id: 'qa_menu-link-benefits'
  },
  groupBooking: {
    titleDesktop: 'header-menu-group-booking',
    titleMobile: '',
    icon: 'fa-users',
    href: externalLinks.groupBooking,
    id: 'qa_menu-link-group-booking'
  },
  realEstate: {
    titleDesktop: 'header-menu-realEstate',
    titleMobile: '',
    menuItems: [
      {
        titleDesktop: 'header-menu-leaseToLimehome',
        titleMobile: '',
        icon: 'fa-hotel',
        href: externalLinks.leaseToLimehome,
        id: 'qa_menu-link-lease-to-limehome'
      },
      {
        titleDesktop: 'header-menu-press',
        titleMobile: '',
        icon: 'fa-newspaper',
        href: externalLinks.press,
        id: 'qa_menu-link-press'
      }
    ]
  }
};
